import React from 'react';

// Bouton des paramètres OneTrust de cookies
const CookieSetting = ({ label }) => {
  const OTToggleInfoDisplay = () => {
    if (window.OneTrust != null) {
      window.OneTrust.ToggleInfoDisplay();
    }
  };

  return (
    <button
      role="button"
      tabIndex="0"
      onClick={OTToggleInfoDisplay}
      className="optanon-show-settings "
    >
      {label}
    </button>
  );
};

export default CookieSetting;
